/**
 * FieldDataType
 *
 * @hidden
 * Should match server enum found at "/EE.Api/DB/Enums.cs"
 */
export enum FieldDataType {
    /* 'none' is a front-end only fieldType used for handling errors: do not display */
    none = -1,
    string = 0,
    text = 1,
    integer = 2,
    float = 3,
    date = 4,
    address = 5,
    tags = 6,
    users = 7,
    segments = 8,
    enum = 9,
}
